// eslint-disable-next-line no-unused-vars
import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import TemplateFighthingComponents from 'components/TemplateFighthing/templateFighthing.components';
import { HasAccess } from '@permify/react-role';
import { ErrorPage404 } from 'common/Error/error.common';

const TemplateFighthingPage = (props: any) => {
   return (
      <Fragment>
         <Helmet>
            <title>เทมเพลตตั้งสู้</title>
         </Helmet>
         <HasAccess
            roles={['Owner']}
            permissions={["payrate-list"]}
            renderAuthFailed={<ErrorPage404 />}
            >
            <TemplateFighthingComponents {...props}/>
         </HasAccess>
      </Fragment>
   );
};

export default TemplateFighthingPage;